import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const FormField = ({ label, children, required = false }) => (
	<Box
		sx={{
			display: 'grid',
			gridTemplateColumns: '120px minmax(0, 1fr)',
			gap: '12px',
			alignItems: 'flex-start',
			py: '7px',
		}}
	>
		<Typography
			component='label'
			sx={{
				fontSize: '11px',
				fontWeight: 500,
				color: 'text.secondary',
				pt: '9px',
			}}
		>
			{label}
			{required && (
				<Box component='span' sx={{ color: 'error.main', ml: '2px' }}>
					*
				</Box>
			)}
		</Typography>

		<Box sx={{ minWidth: 0 }}>{children}</Box>
	</Box>
);

FormField.propTypes = {
	label: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	required: PropTypes.bool,
};

export default FormField;
